import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  border: 3px solid #ff8f4e;
  border-radius: 10px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const IndiaAIFestivalOpportunity = () => {
  const { t } = useTranslation();

  return (
    <div className="w-100">
      <Container>
        <div>
          <h2 className="text-center mb-3">
            {t("impact_festival_2025.opportunity_title")}
          </h2>
          <p>{t("impact_festival_2025.opportunity_description")}</p>
        </div>
      </Container>
    </div>
  );
};

export default IndiaAIFestivalOpportunity;
